import React from 'react';
import classes from './CustomLinearProgress.module.scss';

function CustomLinearProgress(props) {
  const { progress, fullLength } = props;
  return (
    <div className={classes.progress} style={{ width: fullLength }}>
      <div className={classes.progressBar} role="progressbar" style={{ width: `${progress}%` }} />
    </div>
  );
}

export default CustomLinearProgress;
